import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { LogOut, LayoutDashboard, CalendarDays, Settings } from 'lucide-react';
import RoleSwitcher from './RoleSwitcher';
import { useAuth } from '../hooks/useAuth';
import PracticeBanner from './PracticeBanner';
import ReadOnlyBanner from './ReadOnlyBanner';
import ConnectionBanner from './ConnectionBanner';

export default function CrewLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <PracticeBanner />
      <ReadOnlyBanner />
      <ConnectionBanner />
      <header className="bg-brand-700 text-white dark:bg-plum dark:text-snow dark:border-b dark:border-snow/10 px-4 py-3 flex items-center justify-between sticky top-0 z-40 shadow-md">
        <div>
          <div className="font-bold text-base leading-tight">Keep Austin Mowed</div>
          <div className="text-brand-200 dark:text-snow/70 text-xs">{user?.name}</div>
        </div>
        <RoleSwitcher tone="dark" compact />
        <button onClick={logout} className="flex items-center gap-1.5 text-brand-200 hover:text-white dark:text-snow/70 dark:hover:text-snow text-sm py-1 px-2 rounded">
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sign out</span>
        </button>
      </header>

      <main className="flex-1 max-w-lg mx-auto w-full px-4 py-4 pb-24">
        <Outlet />
      </main>

      {/* Bottom tab bar */}
      <nav className="fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-40 safe-area-inset-bottom">
        <div className="max-w-lg mx-auto flex">
          <NavLink to="/crew/dashboard"
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center py-2 text-xs font-medium transition-colors ${isActive ? 'text-brand-600' : 'text-gray-500 hover:text-gray-700'}`
            }>
            <LayoutDashboard className="h-5 w-5 mb-0.5" />
            Dashboard
          </NavLink>
          <NavLink to="/crew/jobs"
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center py-2 text-xs font-medium transition-colors ${isActive ? 'text-brand-600' : 'text-gray-500 hover:text-gray-700'}`
            }>
            <CalendarDays className="h-5 w-5 mb-0.5" />
            Schedule
          </NavLink>
          <NavLink to="/crew/settings"
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center py-2 text-xs font-medium transition-colors ${isActive ? 'text-brand-600' : 'text-gray-500 hover:text-gray-700'}`
            }>
            <Settings className="h-5 w-5 mb-0.5" />
            Availability
          </NavLink>
        </div>
      </nav>
    </div>
  );
}
